import { useCallback } from 'react';
import { apiUserDownloads } from '../resources/api/apiUserDownloads';

const { useGetFile } = apiUserDownloads;

export const useDownload = () => {
  const { execute } = useGetFile();

  return useCallback(
    async (url: string) => {
      const result = await execute(url);
      window.open(result.url, '_blank', 'noopener,noreferrer');
    },
    [execute]
  );
};
